import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

const PALETTE = ["var(--accent)", "var(--accent-2)", "var(--danger)", "var(--success)", "var(--text-faint)"];

export default function DonutCard({ title, subtitle, data, valueKey = "value", labelKey = "label", centerLabel, className = "" }) {
  const total = (data || []).reduce((sum, d) => sum + d[valueKey], 0);
  const primaryPct = total > 0 ? Math.round(((data?.[0]?.[valueKey] || 0) / total) * 100) : 0;

  return (
    <div className={`chart-card donut-card ${className}`}>
      <div className="chart-card__head">
        <div>
          <div className="chart-card__title">{title}</div>
          {subtitle && <div className="chart-card__subtitle">{subtitle}</div>}
        </div>
      </div>
      {!data || data.length === 0 || total === 0 ? (
        <div className="chart-card__empty">No data for this range.</div>
      ) : (
        <div className="donut-card__body">
          <div className="donut-figure">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  dataKey={valueKey}
                  nameKey={labelKey}
                  innerRadius="72%"
                  outerRadius="100%"
                  paddingAngle={2}
                  isAnimationActive
                  animationDuration={700}
                  stroke="var(--surface)"
                  strokeWidth={2}
                >
                  {data.map((_, i) => (
                    <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="donut-figure__center">
              <div className="donut-figure__value">{primaryPct}%</div>
              <div className="donut-figure__label">{centerLabel || "share"}</div>
            </div>
          </div>
          <div className="donut-legend">
            {data.map((d, i) => (
              <div key={d[labelKey]} className="donut-legend__item">
                <span className="donut-legend__dot" style={{ background: PALETTE[i % PALETTE.length] }} />
                {d[labelKey]}
                <span className="donut-legend__count">{d[valueKey].toLocaleString("en-IN")}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
